import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TaskCard } from 'features/task-management';

const TasksList = (props) => {
  const { t } = useTranslation();
  const limit = !props.showAllTasks && props.tasks.length >= props.constantLimit ?
    props.constantLimit : props.tasks.length;
  return (
    <div>
      <p className="text-strong mt-4 mb-2">{t(props.title)}</p>
      {props.tasks.slice(0, limit).map(task => (
        <div key={`task-${task.id}`} className="cards-list">
          <TaskCard
            task={task}
            className={props.cardClassName}
            renderTask={props.renderTask}
            completed
          />
        </div>))}
      {props.tasks.length > props.constantLimit &&
      <button onClick={props.renderTasks} className="btn-link">
        <i className="material-icons">{`${props.showAllTasks ? 'remove' : 'add'}`}</i>
        <span>
          {t(props.showAllTasks ? props.showLessLabel : props.showAllLabel)}
        </span>
      </button>
      }
    </div>
  );
};

export default TasksList;

TasksList.propTypes = {
  tasks: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  cardClassName: PropTypes.string,
};
